import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

// TODO: triggered from drupal brand-specific analytics.js
const defaultData: IDataLayer = {
  enh_action: 'detail',
  event_name: 'product_detail_quickshop',
  event_category: 'ecommerce',
  event_action: null, // <Home/PDP/PLP>
  event_label: null, // '<product name> - <product ID>'
};

function trackQuickView(_: string, eventData: IDataLayer = {}) {
  const data = tealium.dataLayer?.data || {};
  const productIndex =
    data.product_impression_id?.indexOf(eventData?.product_id[0]) || -1;
  if (productIndex >= 0) {
    eventData.event_action = data.page_template;
    eventData.event_label = tealium.dataLayer.formatProductEventLabel({
      product_name: [data.product_impression_name[productIndex]],
      product_id: [data.product_impression_id[productIndex]],
    });
    eventData.product_brand = [data.brand];
    eventData.product_list = [location.pathname];
    eventData.product_name = [data.product_impression_name[productIndex]];
    eventData.product_position = [productIndex + 1];
    eventData.product_price = [data.product_impression_price[productIndex]];
    eventData.product_product_code = [
      data.product_impression_product_code[productIndex],
    ];
    eventData.product_shade = [data.product_impression_shade[productIndex]];
    eventData.product_size = [data.product_impression_size[productIndex]];
    eventData.product_sku = [data.product_impression_sku[productIndex]];
  }

  tealium.evtLink({ ...defaultData, ...eventData });
}

registerAnalyticsEventHandler('quickView', trackQuickView);
